<template lang="pug">
  div
    el-row(type="flex" justify="end")
      el-button.create-button(type="primary" @click="openCreateDialog") {{ $t('Cuona.Group.new') }}
    .content
      GroupsTable.group(:groups="groups" :edit="false" :loading="isLoading" @openCreateDialog="openCreateDialog")

    el-dialog(:title="$t('Cuona.Group.new')" width="65%" top="8vh" :visible.sync="isShowingDialog" @closed="closedDialog")
      el-form.form(label-position="left" :rules="rules" label-width="120px" ref="dialogForm" :model="dialogForm" v-loading="isLoadingGroupSetting")
        el-form-item(:label="$t('Cuona.Group.name')" prop="name")
          el-input(v-model="dialogForm.name")
        el-form-item(:label="$t('Cuona.Group.manager')" prop="manager")
          el-select(v-model="dialogForm.manager" :placeholder="$t('Cuona.Group.choice')")
            el-option(v-for="(manager, index) in ownerAndManagers" :label="manager.name" :value="manager.id" :key="index")
        el-form-item(:label="$t('Cuona.Group.note')")
          el-input(type="textarea" :rows="3" v-model="dialogForm.description")
        el-form-item(label="CUONA")
          .content
            el-table(ref="groupDeviceTable" :data="devices" @row-click="toggleGroupedDevice" @selection-change="setSelectedDevices" cell-class-name="el-table-cell" row-class-name="el-table-row" max-height="300" empty-text="aaaa")
              el-table-column(type="selection" width="55")
              el-table-column(prop="name" :label="$t('Cuona.Device.name')" sortable="")
                template(slot-scope="props")
                  img.device-image(:src="getCuonaImage(props.row)")
                  span {{ props.row.name }}
              el-table-column(width="180px" prop="nfc_uid" :label="$t('Cuona.Device.id')" sortable="")
              el-table-column(prop="groups" :label="$t('Cuona.Event.group')" sortable="")
                template(slot-scope="props")
                  template(v-for="group in props.row.groups")
                    el-tag.tag(size="mini") {{ group.name }}
      span.dialog-footer(slot="footer")
        el-button(@click="isShowingDialog=false" :disabled="isLoadingGroupSetting") {{ $t('Cuona.Group.cancel') }}
        el-button(type="primary" @click="createGroup" :disabled="isLoadingGroupSetting") {{ $t('Cuona.Group.create') }}

</template>

<script>
import GroupsTable from '../GroupsTable'
import GroupApi from '@/api/group'
import DeviceApi from '@/api/cuona'
import UserApi from '@/api/user'
export default {
  components: { GroupsTable },
  data () {
    return {
      isLoading: true,
      isLoadingGroupSetting: false,
      ownerAndManagers: [],
      groups: [],
      devices: [],
      selectedDevices: [],  // グループ作成時にチェックされたCUONA一覧
      images:{
        cube: require('@/assets/cuona_cube.svg'),
        tag: require('@/assets/cuona_seal.svg')
      },
      isShowingDialog: false,
      dialogForm: {
        name: '',
        manager: null,
        description: '',
        deviceIds: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('Cuona.Group.message01'), trigger: 'blur' }
        ],
        manager: [
          { required: true, message: this.$t('Cuona.Group.message02'), trigger: 'change' }
        ]
      }
    }
  },
  title() {
    return this.$t('menus.group')
  },
  mounted() {
    this.getGroupsDevicesUsers();
  },
  methods: {

    getGroupsDevicesUsers: function (){
      const that = this;
      Promise.all([GroupApi.getGroups(), DeviceApi.getDevices(), UserApi.getUser(), UserApi.getManagers()])
        .then(function(values) {
          that.groups = values[0];
          that.devices = values[1];
          that.ownerAndManagers = values[3];
          that.ownerAndManagers.unshift(values[2]);
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Group.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    // グループ作成時のCUONAのチェックをトグル
    toggleGroupedDevice: function(row, event, column) {
      this.$refs.groupDeviceTable.toggleRowSelection(row);
    },

    // グループの作成
    createGroup: function() {
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          if(this.hasDupName(this.groups, this.dialogForm.name)) {
            this.$message({
              showClose: true,
              message: this.$t('Cuona.Group.has_dup_name_group'),
              type: 'error'
            });
            return;
          }
          this.isLoadingGroupSetting = true;
          const ufcUids = this.selectedDevices.map(function(selectedDevice) { return selectedDevice.nfc_uid });
          const params = {
            nfc_uids: ufcUids,
            group: {
              name: this.dialogForm.name,
              description: this.dialogForm.description,
              manager_id: this.dialogForm.manager
            }
          }

          GroupApi.createGroup(params)
            .then((groups) => {
              this.groups = groups;
              this.isShowingDialog = false;
              this.$message({
                showClose: true,
                message: this.$t('Cuona.Group.message06'),
                type: 'success'
              });
            }).catch((error) => {
              let errorMessage = 'Cuona.Group.failed_create';
              switch(error.code) {
                case 409:
                  errorMessage = 'Cuona.Group.has_dup_name_group';
                  break;
              }
              this.$message({
                showClose: true,
                message: this.$t(errorMessage),
                type: 'error'
              });
            }).finally(() => { this.isLoadingGroupSetting = false; });
        } else {
          return false;
        }
      });
    },

    // CUONAのアイコンを設定
    getCuonaImage: function(device) {
      if(device.is_development) {
        return this.images.dev
      } else if(device.device_type == 'tag') {
        return this.images.tag
      } else {
        return this.images.cube
      }
    },

    // グループ作成時にチェックされたCUONA一覧を取得
    setSelectedDevices(val) {
      this.selectedDevices = val;
    },

    // グループ作成ダイアログを開く
    openCreateDialog: function() {
      this.isShowingDialog = true;
    },

    // グループ作成ダイアログを閉じた後の処理
    closedDialog: function() {
      this.$refs['dialogForm'].resetFields();
      this.$refs.groupDeviceTable.clearSelection()
      this.dialogForm.name = ''
      this.dialogForm.manager = null
      this.dialogForm.description = ''
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";
@import "../../../styles/table-layout.scss";

.create-button {
  margin: 20px 40px -20px;
}

.form {
  margin-top: 10px;
}

.group-select {
  width: 100%;
}

.el-dialog {
  .content {
    margin: 0;
  }

  .device-image {
    position: relative;
    top:4px;
    width: 20px;
    margin-right: 8px;
  }

  th {
    font-weight: normal;
    font-size: 12px;
    padding: 0 20px;
    color: #999;
  }

  .el-table-row {
    height: 40px;
  }
}

</style>
